import React, { useState } from 'react';
import '../../styles/faqs.css';
import AnimatedButton from '../AnimatedButton';
import { FaPlus } from 'react-icons/fa';
import AnimationBox from '../../animationBox';

const HorecaFaqs = () => {
  const [selectedQuestion, setSelectedQuestion] = useState('Lorem ipsum dolor sit amet consectetur.');

  // Questions and answers data
  const faqData = [
    {
      question: 'Lorem ipsum dolor sit amet consectetur.',
      answer: 'Lorem ipsum dolor sit amet consectetur. Elementum sed libero commodo sed. Cras lorem facilisis volutpat auctor dis vitae massa velit accumsan. Odio tortor nulla sed malesuada vitae turpis sit. Sem amet dolor porttitor nunc amet sit vulputate cras.',
    },
    {
        question: 'Lorem ipsum dolor sit amet consectetur.',
        answer: 'Lorem ipsum dolor sit amet consectetur. Elementum sed libero commodo sed. Cras lorem facilisis volutpat auctor dis vitae massa velit accumsan. Odio tortor nulla sed malesuada vitae turpis sit. Sem amet dolor porttitor nunc amet sit vulputate cras.',
    },
    {
        question: 'Lorem ipsum dolor sit amet consectetur.',
        answer: 'Lorem ipsum dolor sit amet consectetur. Elementum sed libero commodo sed. Cras lorem facilisis volutpat auctor dis vitae massa velit accumsan. Odio tortor nulla sed malesuada vitae turpis sit. Sem amet dolor porttitor nunc amet sit vulputate cras.',
    },
  ];

  // Function to handle the click and change the selected question
  const handleQuestionClick = (question) => {
    setSelectedQuestion(question);
  };

  return (
    <div id='horecafaq' className='faqs mt-5' style={{}} >
      <AnimationBox>
        <div className='inner-container'>
          

          <div className="gradient-div">
            <div className='left-lines'>
              <div className='right-lines'>
                <div className='bottom-circle'>
                  <div className="myp">
                    <h2>Talk to us</h2>
                  </div>
                  <AnimatedButton text="Contact Us" link="/Horeca-Contact" />
                </div>
              </div>
            </div>
          </div>
        </div>
        </AnimationBox>
    </div>
  );
};

export default HorecaFaqs;
